"use strict";

var _slicedToArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABColor = void 0;

var XYZColor_1 = require("./XYZColor");
/**
 * Represents the CIE LAB color space.
 */


var LABColor = /*#__PURE__*/function () {
  /**
   * Creates new CIE LAB color.
   * @param l - Lightness component in the range [0, 1].
   * @param a - A-component in the range [0, 1].
   * @param b - B-component in the range [0, 1].
   */
  function LABColor(l, a, b) {
    _classCallCheck(this, LABColor);

    this.values = [l, a, b];
  }
  /**
   * The lightness value of the color.
   */


  _createClass(LABColor, [{
    key: "distanceTo",

    /**
     * Computes color difference using the CIE94 formula as defined here:
     * https://en.wikipedia.org/wiki/Color_difference.
     * @remarks It is better to use the CIE DE2000 formula, but it requires significantly more computations.
     * E.g., check this reveiw: http://www.color.org/events/colorimetry/Melgosa_CIEDE2000_Workshop-July4.pdf.
     * @param color - A color to compare.
     * @returns The distance between this and provided colors.
     */
    value: function distanceTo(color) {
      var deltaL = this.values[0] - color.values[0];
      var deltaA = this.values[1] - color.values[1];
      var deltaB = this.values[2] - color.values[2];
      var c1 = Math.sqrt(this.values[1] * this.values[1] + this.values[2] * this.values[2]);
      var c2 = Math.sqrt(color.values[1] * color.values[1] + color.values[2] * color.values[2]);
      var deltaC = c1 - c2;
      var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
      deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
      var sc = 1.0 + 0.045 * c1;
      var sh = 1.0 + 0.015 * c1;
      var deltaLKlsl = deltaL / 1.0;
      var deltaCkcsc = deltaC / sc;
      var deltaHkhsh = deltaH / sh;
      var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
      return i < 0 ? 0 : Math.sqrt(i);
    }
  }, {
    key: "distanceTo_00",
    value: function distanceTo_00(color) {
      var _this$values = _slicedToArray(this.values, 3),
          L1 = _this$values[0],
          a1 = _this$values[1],
          b1 = _this$values[2];

      var _color$values = _slicedToArray(color.values, 3),
          L2 = _color$values[0],
          a2 = _color$values[1],
          b2 = _color$values[2];

      var kL = 1.0;
      var kC = 1.0;
      var kH = 1.0;
      var K1 = 0.045;
      var K2 = 0.015;
      var deg2rad = Math.PI / 180.0;
      var rad2deg = 180.0 / Math.PI;
      var deltaL = L2 - L1;
      var midL = (L1 + L2) / 2;
      var C1 = Math.sqrt(a1 * a1 + b1 * b1);
      var C2 = Math.sqrt(a2 * a2 + b2 * b2);
      var midC = (C1 + C2) / 2;
      var midC7 = Math.pow(midC, 7);
      var midC7Root = Math.sqrt(midC7 / (midC7 + Math.pow(25, 7)));
      var a1t = a1 + 0.5 * a1 * (1 - midC7Root);
      var a2t = a2 + 0.5 * a2 * (1 - midC7Root);
      var C1t = Math.sqrt(a1t * a1t + b1 * b1);
      var C2t = Math.sqrt(a2t * a2t + b2 * b2);
      var midCt = (C1t + C2t) / 2;
      var deltaCt = C2t - C1t;
      var h1 = b1 === 0 && a1t === 0 ? 0 : Math.atan2(b1, a1t) * rad2deg % 360;
      var h2 = b2 === 0 && a2t === 0 ? 0 : Math.atan2(b2, a2t) * rad2deg % 360;
      var deltah = h2 - h1;
      var absDeltah = Math.abs(deltah);

      if (h2 <= h1 && absDeltah > 180) {
        deltah += 360;
      }

      if (h2 > h1 && absDeltah > 180) {
        deltah -= 360;
      }

      var deltaH = 2 * Math.sqrt(C1t * C2t) * Math.sin(0.5 * deltah * deg2rad);
      var H = (h1 + h2) / 2;

      if (absDeltah > 180 && h1 + h2 < 360) {
        H += 180;
      }

      if (absDeltah > 180 && h1 + h2 >= 360) {
        H -= 180;
      }

      var T = 1 - 0.17 * Math.cos((H - 30) * deg2rad) + 0.24 * Math.cos(2 * H * deg2rad) + 0.32 * Math.cos((3 * H + 6) * deg2rad) - 0.20 * Math.cos((4 * H - 63) * deg2rad);
      var SL = 1 + K2 * (midL - 50) / Math.sqrt(20 + (midL - 50) * (midL - 50));
      var SC = 1 + K1 * midCt;
      var SH = 1 + K2 * midCt * T;
      var RT = -2 * midC7Root * Math.sin(60 * Math.exp(-((H - 275) / 25) * ((H - 275) / 25)) * deg2rad);
      var diff = Math.sqrt(Math.pow(deltaL / (kL * SL), 2) + Math.pow(deltaCt / (kC * SC), 2) + Math.pow(deltaH / (kH * SH), 2) + RT * (deltaCt / (kC * SC)) * (deltaH / (kH * SH)));
      return diff;
    }
    /**
     * Computes the distance to a=b=0 in the AB-subspace.
     */

  }, {
    key: "distanceToGray",
    value: function distanceToGray() {
      return Math.sqrt(this.a * this.a + this.b * this.b);
    }
    /**
     * Return a copy of color values in array format as [l, a, b].
     */

  }, {
    key: "toArray",
    value: function toArray() {
      // copy
      return this.values.map(function (v) {
        return v;
      });
    }
    /**
     * Trasforms color to the XYZ format.
     */

  }, {
    key: "toXYZ",
    value: function toXYZ() {
      var y = (this.l * 100 + 16) / 116;
      var x = this.a / 5 + y;
      var z = y - this.b / 2;

      var _map = [x, y, z].map(function (v) {
        var v3 = v * v * v;
        return v3 > 0.008856451 ? v3 : (v - 16 / 116) / 7.787037;
      });

      var _map2 = _slicedToArray(_map, 3);

      x = _map2[0];
      y = _map2[1];
      z = _map2[2];
      return new XYZColor_1.XYZColor(x * XYZColor_1.XYZColor.D65.x, y * XYZColor_1.XYZColor.D65.y, z * XYZColor_1.XYZColor.D65.z);
    }
    /**
     * Trasforms color to the RGB format.
     */

  }, {
    key: "toRGB",
    value: function toRGB() {
      return this.toXYZ().toRGB();
    }
    /**
     * Trasforms color to the sRGB format.
     */

  }, {
    key: "toSRGB",
    value: function toSRGB() {
      return this.toXYZ().toRGB().toSRGB();
    }
  }, {
    key: "l",
    get: function get() {
      return this.values[0];
    }
    /**
     * The a-component of the color (green to red).
     */

  }, {
    key: "a",
    get: function get() {
      return this.values[1];
    }
    /**
     * The b-component of the color (blue to yellow).
     */

  }, {
    key: "b",
    get: function get() {
      return this.values[2];
    }
  }]);

  return LABColor;
}();

exports.LABColor = LABColor;